import { createContext, useContext } from 'react';

export const FormContext = createContext();

export const FormProvider = ({
  formValues,
  setFormValues,
  errorStates,
  setErrorStates,
  touchedStates,
  setTouchedStates,
  enqueueCleanup,
  children,
  variant = 'standard',
}) => {
  const assignValue = (key, value) => {
    setFormValues((prev) => {
      const updatedFormValues = { ...prev, [key]: value };
      return updatedFormValues;
    });
  };

  const assignErrorState = (key, value) => {
    setErrorStates((prev) => {
      const updatedErrorStates = { ...prev, [key]: value };
      return updatedErrorStates;
    });
  };

  const assignTouchedState = (key, value) => {
    setTouchedStates((prev) => {
      const updatedTouchedStates = { ...prev, [key]: value };
      return updatedTouchedStates;
    });
  };

  // The interface for FormFields
  // They have access to all formValues, the mode, as well as functions to assign values and error states
  const value = {
    formValues,
    assignValue,
    errorStates,
    assignErrorState,
    touchedStates,
    assignTouchedState,
    enqueueCleanup,
    variant,
  };

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export const useForm = () => useContext(FormContext);
